import { getSelectedTableView } from 'owa-mail-list-store';
import { resetFocus } from 'owa-mail-focus-manager';
import type { ActionSource } from 'owa-mail-store';
import { lazyBlockLastSendersFromTable } from 'owa-mail-triage-action';
import getEffectiveRowKeys from 'owa-mail-reading-pane-store/lib/utils/getEffectiveRowKeys';

export default function onBlock(actionSource: ActionSource): void {
    const tableView = getSelectedTableView();
    const rowKeys = getEffectiveRowKeys(tableView);

    lazyBlockLastSendersFromTable.importAndExecute(rowKeys, tableView, actionSource);
    resetFocus('blockCommand');
}
